module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6 spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                Articles for Editors Picks:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "editors-picks__list"
  }, [(!_vm.selectedPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                  Please select items to add\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title"
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.deleteEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by article title or url"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.onPageChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('div', {
    staticClass: "editors-picks__list editors-picks__list_with-search"
  }, [_vm._l((_vm.filteredPicks), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "editors-picks__pick-item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "editors-picks__title",
      attrs: {
        "title": item.title
      }
    }, [_c('strong', [_vm._v(_vm._s(item.title || 'No Title'))])]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__text",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.adaptText(item.body) || 'No description') + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "editors-picks__cover",
      on: {
        "click": function($event) {
          return _vm.addEditorsPick(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.filteredPicks.length && !_vm.isLoading) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                    There are no items for your request\n                  ")]) : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Picks\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Editor's Picks have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Edit Editor's Picks For Articles")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new Article")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58745284","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/editorsPicks/EditorsPicksEditArticles.vue
// module id = 910
// module chunks = 0